import React from "react";
import { getIcon } from "../../constants/constants";
import { getPlatformConfig } from "../AssistantDetails/Assistants.utils";
import LoadingComponent from "../../components/common/LoadingComponent";
import { formatPlatformName } from "../../constants/constants";
import MultiSelect from "../../components/common/MultiSelect";

function Configuration({
  setting,
  configurations,
  loading,
  selectedDefaultSettings,
  setSelectedDefaultSettings,
  handleSave,
  isOnboarding,
}) {
  const platform = setting?.integrationId?.name;
  const iconSrc = getIcon(platform);
  const config = getPlatformConfig(platform);
  const stepHeading = `Select ${formatPlatformName(setting?.integrationId?.name)} Default Settings`;

  const fieldData = configurations?.fieldData || {};
  const selectableFields = Object.keys(fieldData).filter(
    (key) => Array.isArray(fieldData[key]) && fieldData[key].length > 0,
  );
  const renderContent = () => {
    if (loading) {
      return <LoadingComponent loading={loading} />;
    }

    if (!selectableFields.length) {
      return (
        <p
          className="text-center py-3 mb-0"
          style={{ color: "rgba(255,255,255,0.3)", fontSize: 14 }}
        >
          No configurable default settings available.
        </p>
      );
    }

    return (
      <div className="row">
        {selectableFields.map((fieldName) => {
          const options = fieldData[fieldName];
          const fieldValue = selectedDefaultSettings[fieldName];

          const selectedValues = Array.isArray(fieldValue)
            ? fieldValue.map((s) => s.key)
            : fieldValue?.key
              ? [fieldValue.key]
              : [];

          return (
            <div className="col-md-12 mb-3" key={fieldName}>
              <label className="form-label ws-label">
                {fieldName}
                <span className="text-danger fs-9">*</span>
              </label>

              <MultiSelect
                options={options.map((o) => ({
                  value: o.key,
                  label: o.value,
                }))}
                value={selectedValues}
                onChange={(selectedKeys) => {
                  const selectedOptions = options.filter((o) =>
                    selectedKeys.includes(o.key),
                  );
                  setSelectedDefaultSettings((prev) => ({
                    ...prev,
                    [fieldName]: selectedOptions.map((opt) => ({
                      key: opt.key,
                      value: opt.value,
                    })),
                  }));
                }}
              />
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div
      className={`container-fluid mt-10 ${!isOnboarding ? "px-4" : ""}`}
      style={
        isOnboarding ? { paddingLeft: "20rem", paddingRight: "20rem" } : {}
      }
    >
      <div className="card">
        <div className="ws-card-header px-4 py-3 d-flex align-items-center gap-3">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center bg-body-emphasis"
            style={{ width: 50, height: 50 }}
          >
            <img
              alt={platform}
              src={iconSrc}
              style={{ width: 22, height: 22 }}
            />
          </div>

          <div>
            <p className="ws-step-heading mb-1">Integration Setup</p>
            <h5 className="mb-0 fw-bold">{config?.title}</h5>
          </div>
        </div>

        {(setting?.maskedAccessToken || setting?.sessionId) && (
          <div className="px-4 py-4 ws-panel">
            <p className="ws-label mb-2">{stepHeading}</p>
            {renderContent()}
          </div>
        )}

        <div className="ws-card-footer px-4 py-3 d-flex justify-content-end gap-2">
          <button
            className="btn btn-primary"
            disabled={
              !selectedDefaultSettings ||
              Object.values(selectedDefaultSettings).every(
                (val) => !val || (Array.isArray(val) && val.length === 0),
              )
            }
            onClick={handleSave}
          >
            Save & Continue
          </button>
        </div>
      </div>
    </div>
  );
}

export default Configuration;
